import {
  ResponsiveModal,
  ResponsiveModalContent,
  ResponsiveModalDescription,
  ResponsiveModalTitle,
} from '@/components/extension/responsive-modal'

import { ResetPasswordForm } from './reset-password-form'

type Props = {
  forgotCode: string
  onClose: () => void
  onSuccess: () => void
}

export const ResetPassword = ({ forgotCode, onClose, onSuccess }: Props) => {
  return (
    <ResponsiveModal
      open
      onOpenChange={(open) => {
        if (!open) {
          onClose()
        }
      }}
    >
      <ResponsiveModalContent
        className='gap-0 border-none px-7 py-10 lg:w-[630px] lg:rounded-md'
        onInteractOutside={(e) => e.preventDefault()}
        aria-describedby={'modal-login'}
      >
        <ResponsiveModalTitle />
        <ResponsiveModalDescription />

        <ResetPasswordForm
          forgotCode={forgotCode}
          onClose={onClose}
          onSuccess={onSuccess}
        />
      </ResponsiveModalContent>
    </ResponsiveModal>
  )
}
